<app-base-modal
  [open]="isOpen()"
  (openChange)="$event ? null : onClose()"
  title="Import job"
  [size]="'lg'"
>
  @if (currentJob(); as job) {
    <div class="flex flex-col gap-4">
      <p class="text-sm text-slate-600" data-testid="job-detail-ready">
        {{ readyCount() }} of {{ papers().length }} ready
      </p>

      <section class="flex flex-col gap-2">
        <h3 class="text-sm font-semibold text-slate-700">Papers</h3>
        @for (p of papers(); track p.id) {
          <div
            class="flex items-center justify-between rounded-md border border-slate-200 p-2"
            [attr.data-paper-id]="p.id"
          >
            <div class="min-w-0">
              <p class="truncate text-sm text-slate-800">{{ p.title || '(untitled)' }}</p>
              <p class="text-xs text-slate-500">
                @if (p.extractionStatus) {
                  extraction: {{ p.extractionStatus }}
                }
                @if (missing(p)) {
                  <span class="text-amber-700"> — {{ missing(p) }}</span>
                }
              </p>
            </div>
            <div class="flex flex-shrink-0 gap-2">
              @if (p.extractionStatus === 'FAILED') {
                <button
                  type="button"
                  class="btn-small-secondary"
                  (click)="onRetry(p)"
                  data-testid="row-retry"
                >
                  Retry extraction
                </button>
              }
              <button
                type="button"
                class="btn-small-secondary"
                (click)="onEdit(p)"
                data-testid="row-edit"
              >
                Edit metadata
              </button>
            </div>
          </div>
        }
      </section>

      @if (failedUploads().length) {
        <section class="flex flex-col gap-2">
          <h3 class="text-sm font-semibold text-red-700">Failed uploads</h3>
          @for (f of failedUploads(); track f.id) {
            <div
              class="flex items-center justify-between rounded-md border border-red-200 bg-red-50 p-2"
            >
              <div class="min-w-0">
                <p class="truncate text-sm text-slate-800">{{ f.filename }}</p>
                <p class="text-xs text-red-700">
                  {{ f.message || f.errorCode || 'Upload failed' }}
                </p>
              </div>
              <div class="flex flex-shrink-0 gap-2">
                @if (job.source === 'PDF') {
                  <input
                    #reupload
                    type="file"
                    accept="application/pdf"
                    class="hidden"
                    (change)="onReupload(f, reupload)"
                  />
                  <button
                    type="button"
                    class="btn-small-secondary"
                    (click)="reupload.click()"
                    data-testid="row-reupload"
                  >
                    Re-upload
                  </button>
                }
                <button
                  type="button"
                  class="btn-small-secondary"
                  (click)="onDismiss(f)"
                  data-testid="row-dismiss"
                >
                  Dismiss
                </button>
              </div>
            </div>
          }
        </section>
      }
    </div>
  }
</app-base-modal>
